// extracted by mini-css-extract-plugin
export default {"menu":"Navigator_menu__CklMw","active":"Navigator_active__J3jRX","mobile_logo":"Navigator_mobile_logo__5NCL2","container":"Navigator_container__T0QKU","show":"Navigator_show__OvLr7"};